(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPeriodoController', SSPeriodoController);

    SSPeriodoController.$inject = ['SSPeriodo'];

    function SSPeriodoController(SSPeriodo) {

        var vm = this;

        vm.sSPeriodos = [];

        loadAll();

        function loadAll() {
            SSPeriodo.query(function(result) {
                vm.sSPeriodos = result;
                vm.searchQuery = null;
            });
        }
    }
})();
